import React from "react";

const CustomerProfiling = () => {
    return (
        <div className="bg-blue-50 dark:bg-gray-900 p-6 rounded-2xl shadow-md max-w-4xl mx-auto mt-10">
            <h2 className="text-2xl font-bold text-blue-900 dark:text-blue-200 mb-4">
                Customer Profiling Analysis
            </h2>

            <p className="text-gray-700 dark:text-gray-300 mb-6">
                The provided customer profiles reveal key patterns, behaviors, and opportunities for businesses to understand their high-value customers better.
            </p>

            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl border border-blue-100 dark:border-blue-800 mb-6">
                <h3 className="text-lg font-semibold text-blue-800 dark:text-blue-300 mb-2">📊 High-Value Customer Traits:</h3>
                <ul className="list-disc list-inside text-gray-800 dark:text-gray-200 space-y-2">
                    <li><strong>Higher Average Order Value:</strong> $2,230.56 vs. $29.09</li>
                    <li><strong>Bigger Orders:</strong> 561.52 items vs. 232.35</li>
                    <li><strong>Higher Order Frequency:</strong> 239.62 vs. 16.01 items per first order</li>
                    <li><strong>Higher Value per Item:</strong> $2.10 vs. $0.39</li>
                    <li><strong>Fewer Evening Purchases:</strong> 0.02 vs. 0.05</li>
                    <li><strong>Fewer Non-Weekend Purchases:</strong> 0.07 vs. 0.15</li>
                </ul>
            </div>

            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl border border-green-100 dark:border-green-800 mb-6">
                <h3 className="text-lg font-semibold text-green-800 dark:text-green-300 mb-2">✅ Key Opportunities:</h3>
                <ul className="list-disc list-inside text-gray-800 dark:text-gray-200 space-y-2">
                    <li><strong>Targeted Marketing:</strong> Focus on high-value customers with larger and frequent orders.</li>
                    <li><strong>Evening & Non-Weekend Promotions:</strong> Incentivize low-traffic times to drive sales.</li>
                    <li><strong>Premium Product Strategy:</strong> Offer high-end options tailored to high-value preferences.</li>
                    <li><strong>Personalized Loyalty Programs:</strong> Reward high-value customers for continued engagement.</li>
                </ul>
            </div>

            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl border border-yellow-100 dark:border-yellow-700">
                <h3 className="text-lg font-semibold text-yellow-800 dark:text-yellow-300 mb-2">💡 Additional Insights:</h3>
                <ul className="list-disc list-inside text-gray-800 dark:text-gray-200 space-y-2">
                    <li><strong>Low Monetary Score:</strong> May indicate financial sensitivity or the need for flexible payment options.</li>
                    <li><strong>Lower Recency Score:</strong> Suggests a need for re-engagement via reminders or follow-ups.</li>
                </ul>
            </div>
        </div>

    );
};

export default CustomerProfiling;